import _extends from 'babel-runtime/helpers/extends';
var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "add-resource-form" }, [_c('el-schema-form', _vm._g(_vm._b({ ref: "form", attrs: { "submit-button": _vm.innerSubmitButton, "config": _extends({}, _vm.$attrs.config, _vm.formConfig) } }, 'el-schema-form', _vm.$attrs, false), _vm.$listeners))], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };